// src/features/stock/components/StockDashboard.tsx
import React, { useState, useEffect } from 'react';
import { useQuery, useQueries } from '@tanstack/react-query';
import { getOutcomeRun, OutcomeRunRequest } from '../../../../shared/lib/apiClient';
import GraphCard from '../../../../shared/components/widgets/GraphCard';
import { subscribeToRuns } from '../../../../services/wsOutcomeService';
import { RawOutcome } from '../../stock/utils/stockHistoryUtils';
import Tabs from '../../../../shared/components/ui/Tabs';
import ProductManagement from './ProductManagement';

interface OutcomeRunResponse extends RawOutcome {
  name: string;
}

export default function StockDashboard() {
  // 0) Define which tabs you want, and keep track of activeTab
  const tabLabels = [
    'Overview',
    'Product Managment',
    'Attributes Management'
  ];
  const [activeTab, setActiveTab] = useState<string>('Overview');


return (
  <section className="space-y-6">
    {/* 1) Render the shared Tabs component at the top. */}
    <Tabs
      tabs={tabLabels}
      activeTab={activeTab}
      onTabChange={(tab) => setActiveTab(tab)}
    />

    {/* 2) Render a common heading. */}
    <h1 className="text-xl font-semibold text-neutral-100">Stock</h1>

    {/* 3) Conditionally render the content per activeTab. */}

     {activeTab === 'Product Managment' && (
       <div className="text-neutral-300 p-4">
         <ProductManagement />
       </div>
     )}

    {activeTab === 'Attributes Management' && (
      <div className="text-neutral-300 p-4">
        {/* Replace this with your Attributes Management component or UI */}
        <p>Attributes Management content goes here.</p>
      </div>
    )}
  </section>
);

}
